'use client';

import { useEffect, useMemo, useState } from 'react';

export function useShouldAnimate() {
  const [reducedMotion, setReducedMotion] = useState(false);
  const [visible, setVisible] = useState(
    typeof document !== 'undefined' ? document.visibilityState === 'visible' : true
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const onMQ = () => setReducedMotion(mq.matches);
    onMQ();
    mq.addEventListener?.('change', onMQ);

    const onVis = () => setVisible(document.visibilityState === 'visible');
    document.addEventListener('visibilitychange', onVis);

    return () => {
      mq.removeEventListener?.('change', onMQ);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, []);

  // Single flag to gate animations
  const shouldAnimate = useMemo(() => visible && !reducedMotion, [visible, reducedMotion]);
  return { shouldAnimate, reducedMotion, visible };
}
